import React, { useState, useEffect } from "react";
import { Button, Typography, Grid, Container, TextField } from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import api from "../../globals/axios";
import { PROCESSING_PLANT_TYPE_CONVENTION } from "../../globals/const";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import LocateLand from "../../components/LocateLand";
import CryptoJS from "crypto-js";
import CustomAppBar from "../../components/AppBar";

const styles = {
  icon: {
    marginRight: 2,
  },
  mainContent: {
    // backgroundColor: palette.background.paper,
    padding: 0.25,
    paddingLeft: 0.5,
    paddingRight: 0.5,
    flexGrow: 1,
  },
  row: {
    item: true,
    container: true,
    spacing: 1,
    justify: "center",
  },
  fab: {
    position: "fixed",
    bottom: 2,
    left: 2,
  },
  fabRow: {},
  fundSelectorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonRow: {
    margin: "10px",
    display: "flex",
    justifyContent: "space-around",
  },
};

export default function CreateProcessingPlant() {
  const classes = styles;
  const [name, setName] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [area, setArea] = useState();
  const [regulator, setRegulator] = useState();
  const [docHash, setDocHash] = useState("");
  const [landType, setLandType] = useState();
  const [location, setLocation] = useState({});
  const [path, setPath] = useState([]);
  const [center, setCenter] = useState({});
  const [userCenter, setUserCenter] = useState({});
  console.log("userCenter", userCenter);

  useEffect(() => {
    getMyLocation();
  }, []);

  const createNFT = async () => {
    const lat = parseInt(location["latitude"] * 100000000);
    const lng = parseInt(location["longitude"] * 100000000);
    const token_type = PROCESSING_PLANT_TYPE_CONVENTION;
    const token_code = `PROCESSINGPLANT${lat}${lng}`;
    const token_attributes = {
      plant_name: name,
      pin_code: pinCode,
      regulator: regulator,
      doc_hash: docHash,
      land_type: landType,
      area: area,
      polygon: path,
    };

    api
      .post(`${SERVER_BASE_ADDRESS}/chain/create-land-nft`, {
        lat,
        lng,
        token_type,
        token_code,
        token_attributes,
      })
      .then((result) => {
        console.log("result", result);
        alert("Processing Plant Created Successfully");
        window.open("/", "_self");
      })
      .catch((err) => {
        alert("Error - " + err.response.data.non_field_errors[0]);
      });
  };

  const getMyLocation = () => {
    const location = window.navigator && window.navigator.geolocation;

    if (location) {
      console.log("Getting location...");
      location.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          console.log({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting location:", error);
          // this.setState({ latitude: 'err-latitude', longitude: 'err-longitude' })
          setLocation({ latitude: 22.862299, longitude: 77.604459 });
          alert(
            "Could not get location. Manually drag the map and recenter plot."
          );
        }
      );
    } else {
      setLocation({ latitude: 22.862299, longitude: 77.604459 });
      alert("Could not get location. Manually drag the map and recenter plot.");
    }
  };

  function arrayBufferToWordArray(ab) {
    var i8a = new Uint8Array(ab);
    var a = [];
    for (var i = 0; i < i8a.length; i += 4) {
      a.push(
        (i8a[i] << 24) | (i8a[i + 1] << 16) | (i8a[i + 2] << 8) | i8a[i + 3]
      );
    }
    return CryptoJS.lib.WordArray.create(a, i8a.length);
  }

  function handleFileSelect(evt) {
    var files = evt.target.files; // FileList object

    // Loop through the FileList and render image files as thumbnails.
    for (var i = 0, f; (f = files[i]); i++) {
      var reader = new FileReader();

      // Closure to capture the file information.
      reader.onloadend = (function () {
        return function (e) {
          var arrayBuffer = e.target.result;

          var hash = CryptoJS.SHA256(arrayBufferToWordArray(arrayBuffer));
          setDocHash(hash);
          //   var elem = document.getElementById("hashValue");
          //   elem.value = hash;
        };
      })(f);
      reader.onerror = function (e) {
        console.error(e);
      };
      reader.readAsArrayBuffer(f);
    }
  }

  useEffect(() => {
    const latitude = location["latitude"];
    const longitude = location["longitude"];
    const width = 0.005; // in degrees
    const height = 0.005; // in degrees

    const mapcenter = {
      lat: location["latitude"],
      lng: location["longitude"],
    };

    setCenter(mapcenter);

    const rectangle = [
      { lat: latitude, lng: longitude },
      { lat: latitude + height, lng: longitude },
      { lat: latitude + height, lng: longitude + width },
      { lat: latitude, lng: longitude + width },
    ];
    console.log(rectangle);
    setPath(rectangle);
  }, [location]);

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div className={classes.mainContent}>
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Typography variant="h5">Create Processing Plant</Typography>

            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="Plant Name"
              type="text"
              id="txtamount"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="PIN/ZIP Code"
              type="number"
              id="txtamount"
              value={pinCode}
              onChange={(event) => setPinCode(event.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="Regulator(Record keeper agency of govt)"
              id="txtamount"
              value={regulator}
              onChange={(event) => setRegulator(event.target.value)}
            />
            <FormControl fullWidth margin="normal">
              <InputLabel id="token-select-label">Plant Type</InputLabel>
              <Select
                labelId="select-person-type-label"
                id="select-person-type"
                value={landType}
                label="Document Type"
                onChange={(e) => {
                  setLandType(e.target.value);
                }}
              >
                <MenuItem value={"distribution_center"}>
                  Crop Processing
                </MenuItem>
                <MenuItem value={"public_warehouse"}>
                  Product Processing
                </MenuItem>
                <MenuItem value={"other"}>Other</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
              }}
            >
              KYC File: <input type="file" onChange={handleFileSelect} />
            </FormControl>
            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="Area ( in acres )"
              type="number"
              id="txtamount"
              value={area}
              onChange={(event) => setArea(event.target.value)}
            />
            <LocateLand
              center={center}
              setCenter={setUserCenter}
              path={path}
              setPath={setPath}
              editable={true}
            />

            <Button
              style={{ marginTop: 10 }}
              variant="contained"
              size="small"
              color="primary"
              onClick={createNFT}
            >
              Create Processing Plant
            </Button>
          </Grid>
        </div>
      </Container>
    </>
  );
}
